import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Set watermark URL via CSS variable so CRA's webpack does not try to resolve a root URL in CSS.
// This keeps the file served from /public while remaining build-friendly.
try {
  const publicUrl = process.env.PUBLIC_URL || '';
  document.documentElement.style.setProperty('--apx-watermark', `url("${publicUrl}/watermark.png")`);
} catch (e) {
  // no-op
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);